<template>
  <page-header-wrapper>
    <div slot="extra">
      <export
        :columns="columns"
        :params="params"
        :url="apiList.getList"
        xlsxName="优惠码列表"
        v-action:export
        class="mr-4"
        @click="getExportData"
      />
      <router-link v-action:add :to="{ path: '/coupons/form' }">
        <a-button icon="plus" type="primary">新建优惠码</a-button>
      </router-link>
    </div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <standard-form-row>
            <div class="ant-pro-page-header-search">
              <a-input-search
                size="large"
                style="width: 80%; max-width: 522px;"
                v-model="params.where.code"
                placeholder="请输入优惠码"
                enter-button
                allow-clear
                @search="getLists()"
              />
              <a-button type="link" @click="() => (this.search = !this.search)">
                高级筛选
                <a-icon :type="search ? 'up' : 'down'" />
              </a-button>
            </div>
          </standard-form-row>
          <template v-if="search">
            <standard-form-row>
              <a-row :gutter="24">
                <a-col :md="12" :lg="12" :sm="24">
                  <a-form-item label="优惠码">
                    <a-input
                      v-model="params.where.title"
                      allow-clear
                      @pressEnter="getLists()"
                      placeholder="请输入要搜索的优惠码"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="12" :lg="12" :sm="24">
                  <a-form-item label="可用证书">
                    <a-spin :spinning="crtsLoad">
                      <a-select
                        placeholder="请选择要筛选的证书"
                        mode="multiple"
                        optionFilterProp="children"
                        allow-clear
                        name="member"
                        v-model="params.where.use_certificate"
                        @change="value => handleChange(value, 'crtsList')"
                      >
                        <a-select-option
                          v-for="item in crtsList"
                          :key="item.id"
                          :disabled="item.disabled"
                        >{{ item.title }}</a-select-option
                        >
                      </a-select>
                    </a-spin>
                  </a-form-item>
                </a-col>
              </a-row>
            </standard-form-row>
            <standard-form-row>
              <a-row :gutter="24">
                <a-col :md="12" :lg="12" :sm="24">
                  <a-form-item label="可用套购">
                    <a-spin :spinning="packsLoad">
                      <a-select
                        placeholder="请选择要筛选的套购"
                        mode="multiple"
                        optionFilterProp="children"
                        name="member"
                        allow-clear
                        v-model="params.where.use_arbitrage"
                        @change="value => handleChange(value, 'packsList')"
                      >
                        <a-select-option
                          v-for="item in packsList"
                          :key="item.id"
                          :disabled="item.disabled"
                        >{{ item.title }}</a-select-option
                        >
                      </a-select>
                    </a-spin>
                  </a-form-item>
                </a-col>
                <a-col :md="12" :lg="12" :sm="24">
                  <a-form-item label="可用课程">
                    <a-spin :spinning="coursesLoad">
                      <a-select
                        placeholder="请选择要筛选的课程"
                        mode="multiple"
                        optionFilterProp="children"
                        name="member"
                        allow-clear
                        v-model="params.where.use_course"
                        @change="value => handleChange(value, 'coursesList')"
                      >
                        <a-select-option
                          v-for="item in coursesList"
                          :key="item.id"
                          :disabled="item.disabled"
                        >{{ item.title }}</a-select-option
                        >
                      </a-select>
                    </a-spin>
                  </a-form-item>
                </a-col>
              </a-row>
            </standard-form-row>
            <standard-form-row>
              <a-row :gutter="24">
                <a-col :md="12" :lg="12" :sm="24">
                  <a-form-item label="使用状态">
                    <a-select v-model="params.where.state" allow-clear @change="getLists()">
                      <a-select-option value>全部</a-select-option>
                      <a-select-option value="1">未使用</a-select-option>
                      <a-select-option value="2">废弃</a-select-option>
                      <a-select-option value="3">已分发</a-select-option>
                      <a-select-option value="4">已使用</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="12" :lg="12" :sm="24">
                  <a-form-item label="日期">
                    <a-range-picker
                      :ranges="{
                        最近七天: [moment().subtract('days', 6), moment()],
                        今天: [moment(), moment()],
                        本月: [moment().startOf('month'), moment()]
                      }"
                      :placeholder="['开始日期', '结束日期']"
                      @change="values => handleChangeDate(values)"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </standard-form-row>
          </template>
        </a-form>
      </div>
    </a-card>
    <a-card style="margin-top: 24px" :bordered="false" title="优惠码列表">
      <div slot="extra" class="d-flex align-items-center">
        <table-tool-bar-list
          class="mr-4"
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />

        <a-dropdown :disabled="selectedRowKeys.length === 0">
          <a-menu slot="overlay">
            <a-menu-item v-action:delete @click="() => handleBatchesDelete()">
              <a-icon type="delete" />批量删除
            </a-menu-item>
            <a-menu-item v-action:update @click="() => handleDistribute(selectedRowKeys)">
              <a-icon type="share-alt" />批量分发
            </a-menu-item>
            <a-menu-item v-action:update @click="() => handleInvaild(selectedRowKeys)">
              <a-icon type="close-circle" />批量废弃
            </a-menu-item>
          </a-menu>
          <a-button>
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>

      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          getCheckboxProps: getCheckboxProps,
          onChange: onSelectChange
        }"
      >
        <template slot="discount" slot-scope="text">
          <div>
            <template>{{ text }}%</template>
          </div>
        </template>
        <template slot="state" slot-scope="cord">
          <a-badge :color="couponStateMap(cord).color" :text="couponStateMap(cord).value" />
        </template>
        <template slot="order" slot-scope="cord">
          <a-tag
            v-for="(item, index) in orderGetRandomColor(cord)"
            :key="index"
            :color="item.color"
            style="margin-bottom: .25rem"
          >
            {{ item.sn }}
          </a-tag>
        </template>
        <template slot="lists" slot-scope="text">
          <a-tag
            v-for="(item, index) in orderGetRandomColor(text)"
            :key="index"
            :color="item.color"
            style="margin-bottom: .25rem;"
          >
            {{ item.title }}
          </a-tag>
        </template>
        <template slot="user_lists" slot-scope="text">
          <a-tag
            v-for="(item, index) in orderGetRandomColor(text)"
            :key="index"
            :color="item.color"
            style="margin-bottom: .25rem"
          >{{ item.real_name }}
          </a-tag>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <template v-if="record.state === 1" v-action:update>
              <a @click="() => handleDistribute(record.id)">分发</a>
              <a-divider type="vertical" />
            </template>
            <template v-if="record.state === 1 || record.state === 2 || record.state === 3" v-action:update>
              <a @click="() => handleInvaild(record.id)">废弃</a>
            </template>
            <template v-if="record.state !== 3 && record.state !== 4" v-action:delete>
              <a-divider type="vertical" />
              <a-popconfirm
                title="确认删除？"
                ok-text="是"
                cancel-text="否"
                @confirm="() => handleBatchesDelete(record.id)"
              >
                <a>删除</a>
              </a-popconfirm>
            </template>
            <template v-if="record.state !== 4" v-action:update>
              <a-divider type="vertical" />
              <router-link v-action:update :to="'/coupons/edit/'+record.id">
                <a>编辑</a>
              </router-link>
            </template>
          </div>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, select } from '@/mixins' // 引入
import { TableToolBarList, StandardFormRow, Export } from '@/components'
import { ModelDetail, ModelForm, ModelInvaild } from './modules'
import { getRandomLightColor } from '@/utils/util'
const apiList = {
    getList: '/coupons',
    delete: '/coupons',
    coursesList: '/courses/select',
    crtsList: '/certificates/select',
    packsList: '/courses/packs/select'
}
const columns = [

    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '标题',
        dataIndex: 'title',
        scopedSlots: { customRender: 'name' }
    },
    {
        title: '折扣',
        dataIndex: 'discount',
        sorter: true,
        scopedSlots: { customRender: 'discount' }
    },
    {
        title: '优惠码',
        dataIndex: 'code'
    },
    {
        title: '可用课程',
        dataIndex: 'use_course',
        width: 280,
        scopedSlots: { customRender: 'lists' }
    },
    {
        title: '可用证书',
        dataIndex: 'use_certificate',
        width: 280,
        scopedSlots: { customRender: 'lists' }
    },
    {
        title: '可用套购',
        dataIndex: 'use_arbitrage',
        width: 280,
        scopedSlots: { customRender: 'lists' }
    },
    {
        title: '可用次数',
        dataIndex: 'limit_count',
        sorter: true
    },
    {
        title: '已用次数',
        dataIndex: 'use_count',
        sorter: true
    },
    {
        title: '可用用户',
        dataIndex: 'use_user',
         scopedSlots: { customRender: 'user_lists' }
    },
    {
        title: '可用手机号',
        dataIndex: 'use_phone'
    },
    {
        title: '可用邮箱',
        dataIndex: 'use_email'
    },
    {
        title: '使用人',
        dataIndex: 'member.real_name'
    },
    {
        title: '接收邮箱',
        dataIndex: 'receivers'
    },
    {
        title: '分发时间',
        sorter: true,
        dataIndex: 'distribute_time'
    },
    {
        title: '截止时间',
        sorter: true,
        dataIndex: 'end_at'
    },
    {
        title: '创建时间',
        sorter: true,
        dataIndex: 'created_at'
    },
    {
        title: '状态',
        dataIndex: 'state',
        scopedSlots: { customRender: 'state' }
    },
    {
        title: '订单号',
        dataIndex: 'order',
        width: 220,
        scopedSlots: { customRender: 'order' }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]

export default {
    name: 'CouponList',
    mixins: [list, table, select], // 使用mixins
    components: {
        TableToolBarList,
        StandardFormRow,
        ModelDetail,
        ModelForm,
        Export
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)), // 深度复制表头
            selectedRowKeys: [], // table批量选择
            scroll: { x: 3200 },
            exportList: [],
            coursesLoad: false, // 课程下拉加载
            coursesList: [], // 课程下拉数据
            packsList: [], // 套购下拉列表
            packsLoad: false, // 套购下拉加载
            crtsLoad: false, // 证书下拉加载
            crtsList: [] // 证书下拉列表
        }
    },
    mounted () {
        this.getLists() // 获取分类列表
        this.getSelectLists({
            url: apiList.coursesList,
            type: 'coursesList',
            load: 'coursesLoad'
        }) // 获取下拉列表
        this.getSelectLists({
            url: apiList.packsList,
            type: 'packsList',
            load: 'packsLoad'
        }) // 获取下拉列表
        this.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoad'
        }) // 获取下拉列表
    },
    computed: {
        orderGetRandomColor (arr) {
            return function (arr) {
                const newArr = arr.filter(item => {
                    item.color = getRandomLightColor()
                    return true
                })
                return newArr
            }
        },
        couponStateMap () {
            return function (status) {
                const statusMap = {
                    1: { value: '未使用', color: '#eee' },
                    2: { value: '废弃', color: 'red' },
                    3: { value: '已分发', color: 'gold' },
                    4: { value: '已使用', color: 'green' }
                }
                return statusMap[status]
            }
        }
    },
    methods: {
        /**
         * 获取打印数据
         * @jdy
         *newColumns,data
         * @2020-11-30
         */
        getExportData (columns, data) {
            data.filter(item => {
                item.state = this.couponStateMap(item.state).value
                item.price = parseInt(item.price)
            })
            this.outputXlsxFile(columns, data, '**优惠码列表' + this.moment(new Date()).format('YYYYMMDDHHmmss'))
        },
        /**
         * 列表选择
         * 获取选择的id数组及选择行数据
         * @jdy
         */
        onSelectChange (selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        /**
         * 选择框的默认属性配置
         * state !== 1 时disabled
         * @jdy
         * @2020-10-16
         */
        getCheckboxProps (record) {
            return {
                props: {
                    disabled: record.state === 4
                }
            }
        },
        /**
         * 搜索框筛选
         */
        searchInput (val) {
            if (!val.target.value) {
                delete this.params.where.title
            }
            this.getLists()
        },
        /**
         * 状态筛选
         * {param}
         * @param
         */
        searchState (val) {
            if (!val.target.value) {
                delete this.params.where.state
            }
            this.getLists()
        },
        /**
         * 弹窗展示
         * aid广告id
         * @params
         *
         * ModelDetail
         */
        handleDetailShow (info) {
            this.$dialog(
                ModelDetail,
                // component props
                {
                    info,
                    on: {
                        ok () {},
                        cancel () {},
                        close () {}
                    }
                },
                // modal props
                {
                    title: '优惠码详情',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        },
        /**
         * 分发
         * @params
         * {id}
         * @jdy
         */
        handleDistribute (tid) {
            let ids = []
            if (typeof tid === 'number') {
                ids.push(tid.toString())
            } else {
                ids = tid.map(item => {
                    return item.toString()
                })
            }
            const that = this
            that.$dialog(
                ModelForm,
                {
                    tid: ids,
                    on: {
                        ok () {
                            that.getLists()
                        },
                        cancel () {
                            console.log('cancel 回调')
                        },
                        close () {
                            console.log('modal close 回调')
                        }
                    }
                },
                {
                    title: '分发',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        },
        handleInvaild (tid) {
            let ids = []
            if (typeof tid === 'number') {
                ids.push(tid.toString())
            } else {
                ids = tid.map(item => {
                    return item.toString()
                })
            }
            const that = this
            that.$dialog(
                ModelInvaild,
                {
                    tid: ids,
                    on: {
                        ok () {
                            that.getLists()
                        },
                        cancel () {
                            console.log('cancel 回调')
                        },
                        close () {
                            console.log('modal close 回调')
                        }
                    }
                },
                {
                    title: '作废',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        }
    }
}
</script>
